import PropTipsView from './ProTipsView';

export default PropTipsView;
